import { createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' 
import rootReducer from './reducer/Index'
 
const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
// export const store = createStore(persistedReducer,composeWithDevTools())
export const store = createStore(persistedReducer)

export const persistor = persistStore(store)
 
